import React from 'react';
import { Phone, MapPin, CheckCircle } from 'lucide-react';
import './ServiceAreas.css';

const ServiceAreas = () => {
  const northernSuburbs = [
    'Ballajura', 'Malaga', 'Balcatta', 'Dianella', 'Morley',
    'Noranda', 'Beechboro', 'Lockridge', 'Kiara', 'Marangaroo',
    'Girrawheen', 'Koondoola', 'Mirrabooka', 'Nollamara', 'Westminster',
    'Inglewood', 'Mount Lawley', 'Yokine', 'Tuart Hill', 'Osborne Park'
  ];

  return (
    <div className="service-areas-page">
      {/* Hero Section */}
      <section className="areas-hero">
        <div className="container">
          <h1 className="display-medium">Service Areas</h1>
          <p className="body-large" style={{ marginTop: '16px', maxWidth: '700px' }}>
            We proudly service Perth's Northern Suburbs and surrounding areas. Based in Ballajura, we provide fast, reliable lawn coring and verti-mowing services across the region.
          </p>
        </div>
      </section>

      {/* Primary Service Area */}
      <section className="primary-area">
        <div className="container">
          <div className="area-card primary">
            <div className="area-header">
              <MapPin size={40} color="#004534" />
              <div>
                <h2 className="heading-2">Perth Northern Suburbs</h2>
                <p className="body-medium" style={{ marginTop: '8px' }}>Our primary service area</p>
              </div>
            </div>
            <div className="suburbs-grid">
              {northernSuburbs.map((suburb, index) => (
                <div key={index} className="suburb-item">
                  <CheckCircle size={16} color="#004534" />
                  <span>{suburb}</span>
                </div>
              ))}
            </div>
            <p className="body-medium" style={{ marginTop: 'var(--spacing-large)' }}>
              These are our core service suburbs where we offer same-day or next-day availability for most jobs.
            </p>
          </div>
        </div>
      </section>

      {/* Other Areas */}
      <section className="other-areas">
        <div className="container">
          <div className="area-card">
            <h2 className="heading-2">Other Perth Metro Areas</h2>
            <p className="body-large" style={{ marginTop: '16px' }}>
              While we focus on the Northern Suburbs, we may be able to service other Perth metro areas depending on availability and job size.
            </p>
            <p className="body-medium" style={{ marginTop: 'var(--spacing-medium)' }}>
              If your suburb isn't listed above, please contact us to discuss. We're happy to assess your needs and see if we can help.
            </p>
            <div className="contact-options" style={{ marginTop: 'var(--spacing-large)' }}>
              <a href="tel:0417910217" className="btn-primary">
                <Phone size={20} />
                Call 0417 910 217
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Business Location */}
      <section className="location-section">
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
            Our Location
          </h2>
          <div className="location-card">
            <div className="location-info">
              <h3 className="heading-3">Perth Lawn Coring</h3>
              <div className="address-item">
                <MapPin size={24} color="#004534" />
                <div>
                  <p className="body-medium">
                    28 Pelican Parade<br />
                    Ballajura WA 6066
                  </p>
                  <p className="caption" style={{ marginTop: '4px' }}>
                    Google Plus Code: 5V4W+MX Ballajura
                  </p>
                </div>
              </div>
              <div className="contact-item">
                <Phone size={24} color="#004534" />
                <div>
                  <p className="body-medium">0417 910 217</p>
                  <p className="caption">8:00 AM - 5:00 PM AWST</p>
                </div>
              </div>
            </div>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3383.0123456789!2d115.8972132!3d-31.8433377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a32b1a05b059e89%3A0xc232398bd53b3863!2s28%20Pelican%20Parade%2C%20Ballajura%20WA%206066!5e0!3m2!1sen!2sau!4v1234567890"
                width="100%"
                height="400"
                style={{ border: 0, borderRadius: '16px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Perth Lawn Coring Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="areas-cta">
        <div className="container">
          <div className="cta-banner">
            <h2 className="heading-1" style={{ color: 'white' }}>Not Sure If We Service Your Area?</h2>
            <p className="body-large" style={{ color: 'rgba(255, 255, 255, 0.9)', marginTop: '16px' }}>
              Give us a call and we'll let you know straight away.
            </p>
            <div className="cta-buttons">
              <a href="tel:0417910217" className="btn-cta" style={{ background: 'white', color: 'var(--brand-dark)' }}>
                <Phone size={20} />
                Call 0417 910 217
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Sticky CTA */}
      <div className="mobile-cta-sticky">
        <a href="tel:0417910217" className="btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
          <Phone size={18} />
          Call Now: 0417 910 217
        </a>
      </div>
    </div>
  );
};

export default ServiceAreas;